import type { GossipItem } from '@/mocks/gossip';
import { starNews } from '@/mocks/gossip';
import SectionHeading from './SectionHeading';

function StarCard({ item, index }: { item: GossipItem; index: number }) {
  return (
    <article id={item.id} className="group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-colors hover:border-background-300">
      <div className="relative aspect-[16/10] w-full overflow-hidden">
        <img
          src={item.img}
          alt={item.alt}
          title={`${item.title} - 吃瓜视界`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-3 py-1 text-xs font-semibold text-background-50 ${
            index === 0 ? 'bg-accent-500' : index < 3 ? 'bg-primary-500' : 'bg-foreground-950/70 backdrop-blur'
          }`}
        >
          {item.tag}
        </span>
        <span className="absolute bottom-3 right-3 inline-flex items-center gap-1 rounded-full bg-foreground-950/55 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
          <i className="ri-time-line" style={{ width: 13, height: 13 }} />
          {item.time}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="line-clamp-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {item.title}
        </h3>
        <p className="mt-2.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
        <div className="mt-auto flex items-center gap-4 pt-4 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-eye-line" style={{ width: 14, height: 14 }} />
            {item.views}
          </span>
          <span className="inline-flex items-center gap-1">
            <i className="ri-chat-1-line" style={{ width: 14, height: 14 }} />
            {item.comments}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function NewsGrid() {
  return (
    <section id="star" className="bg-background-100/60 py-14 md:py-20" aria-labelledby="star-title">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHeading
          eyebrow="Celebrity & Showbiz"
          title="明星八卦 · 台前幕后"
          desc="红毯造型、综艺现场、舞台演出、剧组路透……把圈内最新鲜的一手动向，整理成清爽的卡片喂给你。"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-3">
          {starNews.map((item, index) => (
            <StarCard key={item.id} item={item} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}